import { Component, OnInit } from '@angular/core';
import { Tracking} from '../../../_models/tracking';
import { User } from '../../../_models/user';
import * as fromTracking from '../../../tracking/state/tracking.reducer';
import * as trackingActions from '../../../tracking/state/tracking.actions';
import * as fromRoot from '../../../state/app.reducer';
import * as rootActions from '../../../state/app.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './tracking-edit-shell.component.html'
})

export class TrackingEditShellComponent implements OnInit {

    // errorMessage$: Observable<string>;
    tracking$: Observable<Tracking>;
    userList$: Observable<User[]>;

  constructor(
    private storeRoot: Store<fromRoot.State>,
    private store: Store<fromTracking.State>
  ) {

    // Se cargan los agentes comerciales.
    this.store.dispatch( new trackingActions.LoadUsers());
  }

  ngOnInit() {

    this.tracking$ = this.store.pipe(select(fromTracking.getCurrentTracking)) as Observable<Tracking>;

    // Se obtienen los agentes comerciales.
    this.userList$ = this.store.pipe(select(fromTracking.getUserList)) as Observable<User[]>;

  }

  saveTracking(trackingIn: Tracking): void {

    console.log('---> saveTracking trackingIn:');
    console.log(trackingIn);

    if (trackingIn.id === null) {
      console.log('Se va a CREAR un nuevo elemento.');
      this.store.dispatch( new trackingActions.CreateTracking(trackingIn));
    } else {
      console.log('Se va a MODIFICAR un elemento existente.');
      this.store.dispatch( new trackingActions.UpdateTracking(trackingIn));
    }
  }

  // --------------------------------------------------------------
  // Función para mostrar la ventana genérica de información.
  showInfoModal(modalParams) {

    console.log('---->>>>.... Ejecutando tracking-edit-shell showInfoModal: '
    + modalParams.value + ' ;Info: ' + modalParams.info + ' ;Link: ' + modalParams.link + ' ;Skin: ' + modalParams.skin);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({
      value: modalParams.value,
      info: modalParams.info,
      link: modalParams.link,
      param: modalParams.param,
      skin: modalParams.skin
    }));

  } // End function showInfoModal


} // End class TrackingEditShellComponent
